(function () {
    // Default settings
    const defaultSettings = {
        enabled: true,
        messages: ['a.li.ás 👋 We\'re still here', 'a.li.ás 🔥 Don\'t let exclusivity slip away!'],
        messageDelay: 3000, // Initial delay before showing messages (3 seconds)
        messageInterval: 3000 // Interval between message changes (3 seconds)
    };

    // Initialize tab notification
    function initTabNotification() {
        const originalTitle = document.title;
        let interval;
        let isBlurred = false;

        function updateTitle() {
            if (!isBlurred) {
                clearInterval(interval);
                document.title = originalTitle;
                return;
            }

            const messages = window.theme?.tabNotification?.messages || defaultSettings.messages;
            const currentIndex = messages.indexOf(document.title);
            const nextIndex = (currentIndex + 1) % messages.length;
            document.title = messages[nextIndex];
        }

        window.addEventListener('blur', function () {
            if (window.theme?.tabNotification?.enabled) {
                isBlurred = true;
                const messages = window.theme.tabNotification.messages || defaultSettings.messages;
                clearInterval(interval); // Clear any existing interval
                setTimeout(() => {
                    if (isBlurred) {
                        document.title = messages[0];
                        interval = setInterval(updateTitle, defaultSettings.messageInterval);
                    }
                }, defaultSettings.messageDelay);
            }
        });

        window.addEventListener('focus', function () {
            isBlurred = false;
            clearInterval(interval);
            document.title = originalTitle;
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTabNotification);
    } else {
        initTabNotification();
    }
})();